import {Box, Link} from '@miro-site/core'
import React from 'react'
import styled from 'styled-components'

export type IPreviewMode = {
  stopPreviewPath?: string
}

const PreviewMode = (props: IPreviewMode): React.ReactElement => {
  const {stopPreviewPath = '/api/stop-preview'} = props

  return (
    <PreviewModeWrapper $p={12}>
      Preview mode is enabled.&nbsp;
      <Link $variant="default" $color="pink" href={stopPreviewPath} title="Exit preview">
        Click here
      </Link>
      &nbsp; to stop.
    </PreviewModeWrapper>
  )
}

const PreviewModeWrapper = styled(Box)`
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 9999;
  background-color: ${props => props.theme.colors.primaryIndigo};
  text-align: center;
  color: ${props => props.theme.colors.primaryWhite};
`

export default PreviewMode
